import { Tenant } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetTenantsQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/tenants`
	return useQuery<void, TenantsOutput>(url)
}
interface TenantsOutput {
	tenants: Tenant[]
}
